export default "__VITE_ASSET__BO2ZjBZS__"